'use client';
import React from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

const TestimonialsSlider = ({ testimonials }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="bg-gray-100 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800">Témoignages</h2>
          <p className="text-gray-500 mt-2">
            Ce que nos clients disent à propos de DYMIS.
          </p>
        </div>

        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="px-4 py-10">
              <div className="bg-white rounded-2xl shadow-md p-6 h-[250px] flex flex-col justify-between hover:shadow-xl transition duration-300 ">
                <p className="text-gray-600 text-lg leading-relaxed italic mb-4">
                  “{testimonial.feedback}”
                </p>
                <div className="text-right mt-auto">
                  <span className="text-base font-semibold text-blue-700">
                    — {testimonial.name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialsSlider;
